import { Col, Form, Row } from "antd";
import React from "react";
import CleanButton from "../../../common/components/CleanButton";
import Page from "../../../common/components/Page";
import QueryDateRange from "../../../common/components/QueryDateRange";
import { QueryList } from "../../../common/constants/Helpers";
import useQuery from "../TR-CR-Query/useQuery";

const DailyCivilQuery = () => {
  const { Title, Toolbar, Content } = Page;
  const { handleSubmit, form } = useQuery();

  return (
    <Page>
      <Title title="Daily Civil Query" icon="columns" />
      Dates must be in the form MM/DD/YYYY (Example: 01/31/2012). If no dates are given, then today's date will be used.
      <Toolbar>
        <CleanButton onClick={() => handleSubmit(QueryList.CivilDaily)} icon="check-double">
          Submit
        </CleanButton>
      </Toolbar>
      <Content>
        <Form layout="vertical" form={form}>
          <Row gutter={[16, 16]}>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <QueryDateRange form={form} />
            </Col>
          </Row>
        </Form>
      </Content>
    </Page>
  );
};

export default DailyCivilQuery;
